import {
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Table as MuiTable,
  Box,
  Typography,
} from "@mui/material";
import sortBy from "lodash-es/sortBy";
import { ReactElement } from "react";

import { StatusTableHeaderCell } from "./styles";
import { MessageStatusBreakdown } from "./types";

export const CarrierFilteringTable = ({
  messageStatusBreakdown,
}: {
  messageStatusBreakdown: MessageStatusBreakdown;
}): ReactElement => {
  const { maybeFilteredThreshold, carrierFiltering } = messageStatusBreakdown;

  const data = carrierFiltering.map(entry => {
    const { sentCount, filteredCount, maybeFilteredCount } = entry;

    const totalFiltered =
      sentCount > 0 && maybeFilteredCount / sentCount > maybeFilteredThreshold
        ? filteredCount + maybeFilteredCount
        : filteredCount;

    return {
      ...entry,
      filteredCount: totalFiltered,
      filterPct: sentCount > 0 ? totalFiltered / sentCount : 0,
    };
  });

  return (
    <Box sx={{ padding: "14px 16px 50px" }}>
      <Typography variant="body1">Carrier Filtering</Typography>
      <MuiTable>
        <TableHead>
          <TableRow>
            <StatusTableHeaderCell>Carrier</StatusTableHeaderCell>
            <StatusTableHeaderCell>Messages Sent</StatusTableHeaderCell>
            <StatusTableHeaderCell>Messages Filtered</StatusTableHeaderCell>
            <StatusTableHeaderCell>Filter %</StatusTableHeaderCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {sortBy(data, "filterPct").map(
            ({ carrier, sentCount, filteredCount, filterPct }) => (
              <TableRow key={carrier}>
                <TableCell>{carrier}</TableCell>
                <TableCell>{sentCount.toLocaleString()}</TableCell>
                <TableCell>{filteredCount.toLocaleString()}</TableCell>
                <TableCell>{(filterPct * 100).toFixed(1)}%</TableCell>
              </TableRow>
            )
          )}
        </TableBody>
      </MuiTable>
    </Box>
  );
};
